<template>
    <div class="mt-5 d-flex flex-column">
        <div class="container">
            <div class="w100 d-flex justify-content-between">
                <h1>Aktueller Mitarbeiter</h1>
                <div class="d-flex flex-column">
                    <b-button class="mb-3 p-2" @click="showModal" variant="primary">Neuer Mitarbeiter
                        anlegen</b-button>
                    <b-button class="p-2" @click="showstaffDistributionModal"
                        variant="outline-primary">Personalverteilung
                        nach
                        Bereichen</b-button>
                </div>
            </div>
            <div class="mt-3 mb-3">
                <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0">
                    Daten erfolgreich gespeichert.
                </b-alert>
                <b-alert :show="dismissCountDownError" dismissible variant="danger"
                    @dismissed="dismissCountDownError = 0">
                    Leider ist bei der Erstellung oder Bearbeitung des Mitarbeiterkontos ein Fehler aufgetreten.
                </b-alert>
            </div>
            <div>
                <b-modal no-close-on-backdrop no-close-on-esc ref="add-employee-modal" hide-footer
                    :title="enableEditButton ? 'Bearbeiten' : 'Mitarbeiter anlegen'" size="md">
                    <div class="d-block text-center">
                        <b-alert show v-if="showWarning" variant="danger">Füllen Sie die Felder korrekt
                            aus.</b-alert>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="name">Vorname</label>
                            <b-form-input id="name" v-model="name"
                                placeholder="Mitarbeiter name eingeben"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Nachname</label>
                            <b-form-input id="surname" v-model="surname"
                                placeholder="Mitarbeiter name eingeben"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-start align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start">Status</label>
                            <div class="w-100 d-flex  justify-content-start align-items-center">
                                <div>
                                    <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start">Logistikbereich</label>
                            <div class="w-100 d-flex  justify-content-start align-items-center">
                                <b-form-select v-model="selectedArea" :options="areaOptions"></b-form-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-100">
                        <b-button v-if="enableEditButton" class="mt-2" variant="outline-primary" block
                            @click="saveChanges">
                            Änderungeng
                            speichern</b-button>
                        <b-button v-else class="mt-2" variant="outline-primary" block @click="save">Speichern</b-button>
                        <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Abbrechen</b-button>
                    </div>
                </b-modal>
            </div>
            <div>
                <b-modal no-close-on-backdrop no-close-on-esc ref="Warehouse-area-modal" hide-footer title="Anzahl der Mitarbeiter  nach Logistik
                        Bereichen">
                    <div class="d-block text-center">
                        <b-alert show v-if="showWarningStaffDistribution" variant="danger">Füllen Sie die Felder
                            korrekt</b-alert>
                        <b-alert show v-if="showFetchWarning" variant="danger">Datensätze könnten aus der Datenbank
                            geladen werden. Bitte abbrechen und erneut versuchen. </b-alert>
                        <div class="d-flex  d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="name">Head of Logistics:</label>
                            <b-form-input class="w-50" id="name" v-model="staffDistribution.headOfLogistics"
                                type="number"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Wareneingang:</label>
                            <b-form-input class="w-50" type="number"
                                v-model="staffDistribution.wareneingang"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Warenausgang:</label>
                            <b-form-input class="w-50" v-model="staffDistribution.warenausgang"
                                type="number"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Aushilfe:</label>
                            <b-form-input class="w-50" v-model="staffDistribution.aushilfe"
                                type="number"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">MiniJobber:</label>
                            <b-form-input class="w-50" v-model="staffDistribution.miniJobber"
                                type="number"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Auszubildende:</label>
                            <b-form-input class="w-50" v-model="staffDistribution.auszubildende"
                                type="number"></b-form-input>
                        </div>
                        <div class="d-flex justify-content-between d-flex align-items-center p-2">
                            <label class="w-50 d-flex justify-content-start" for="surname">Dropshipping:</label>
                            <b-form-input class="w-50" v-model="staffDistribution.dropshipping"
                                type="number"></b-form-input>
                        </div>
                    </div>
                    <div class="w-100">
                        <b-button class="mt-2" variant="outline-primary" block
                            @click="saveStaffDistribution">Speichern</b-button>
                        <b-button class="mt-3" variant="outline-danger" block
                            @click="hideStaffDistributionModal">Abbrechen</b-button>
                    </div>
                </b-modal>
            </div>
        </div>
        <div class="mb-3">
            <div v-if="sortedAreaList.headOfLogistics.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Head of Logistics</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.headOfLogistics" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.warenausgang.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Warenausgang</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.warenausgang" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.wareneingang.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Wareneingang</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.wareneingang" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.miniJobber.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Mini Jobber</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.miniJobber" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.aushilfe.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Aushilfe</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.aushilfe" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.dropshipping.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Dropshipping</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.dropshipping" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sortedAreaList.auszubildende.length > 0" class="container mt-5 w-100">
                <div class="selected-area">
                    <h3>Auszubildende</h3>
                </div>
                <div class="list-header w-100">
                    <h5>Vorname</h5>
                    <h5>Nachname</h5>
                    <h5>Status</h5>
                </div>
                <div class="employee-list" v-for="item in sortedAreaList.auszubildende" :key="item.id">
                    <div class="employee w-100">
                        <div>
                            <p>{{ item.name }}</p>
                        </div>
                        <div>
                            <p>{{ item.surname }}</p>
                        </div>
                        <div>
                            <p>{{ item.selectedStatus }}</p>
                        </div>

                        <div class="d-flex justify-content-around">
                            <b-button class="mr-3" @click="enableEdit(item)"
                                variant="outline-primary">Bearbeiten</b-button>
                            <b-button @click="deleteEmployee(item.id)" variant="outline-danger">Löschen</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getDatabase, ref, set, onValue, update, remove, get } from "firebase/database";

export default {
    name: 'AttendanceSheet',
    data() {
        return {
            name: null,
            surname: null,
            showWarning: false,
            showWarningStaffDistribution: false,
            showFetchWarning: false,
            selectedStatus: null,
            statusOptions: [
                { value: null, text: 'Bitte Status auswählen' },
                { value: 'Anwesend', text: 'Anwesend' },
                { value: 'Abwesend', text: 'Abwesend' },
                { value: 'Im Urlaub', text: 'Im Urlaub' },
                { value: 'Krankgemeldet', text: 'Krankgemeldet' },
            ],
            selectedArea: null,
            areaOptions: [
                { value: null, text: 'Bitte Lagerbereich auswählen' },
                { value: 'Head of Logistics', text: 'Head of Logistics' },
                { value: 'Wareneingang', text: 'Wareneingang' },
                { value: 'Warenausgang', text: 'Warenausgang' },
                { value: 'Aushilfe', text: 'Aushilfe' },
                { value: 'MiniJobber', text: 'MiniJobber' },
                { value: 'Auszubildende', text: 'Auszubildende' },
                { value: 'Dropshipping', text: 'Dropshipping' },
            ],
            dismissSecs: 5,
            dismissCountDown: 0,
            dismissCountDownError: 0,
            enableEditButton: false,
            tempEmployeeId: null,
            attendanceSheet: [],
            sortedEmployeeList: [],
            sortedAreaList: {
                headOfLogistics: [],
                wareneingang: [],
                warenausgang: [],
                aushilfe: [],
                miniJobber: [],
                auszubildende: [],
                dropshipping: [],
            },

            staffDistribution: {
                headOfLogistics: null,
                wareneingang: null,
                warenausgang: null,
                aushilfe: null,
                miniJobber: null,
                auszubildende: null,
                dropshipping: null
            }

        }
    },
    watch: {
        attendanceSheet: {
            deep: true,
            handler(newValue) {
                if (newValue) {
                    this.handleData();
                }
            }
        }
    },
    methods: {
        showModal() {
            this.$refs['add-employee-modal'].show()
        },
        showstaffDistributionModal() {
            this.$refs['Warehouse-area-modal'].show();
            get(ref(getDatabase(), `laborAllocation/`)).then((snapshot) => {
                if (snapshot.exists()) {
                    this.staffDistribution = snapshot.val().areaDistribution;
                } else {
                    console.log("No data available");
                }
                this.showFetchWarning = false;
            }).catch((error) => {
                this.showFetchWarning = true;
                console.error(error);
            });
        },
        hideModal() {
            this.$refs['add-employee-modal'].hide();
            this.name = null;
            this.surname = null;
            this.selectedArea = null;
            this.selectedStatus = null;
            this.enableEditButton = false;
            this.tempEmployeeId = null;
        },
        showSuccessAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        showErrorAlert() {
            this.dismissCountDownError = this.dismissSecs
        },
        async save() {
            if (
                this.name !== null &&
                this.surname !== null &&
                this.selectedStatus !== null &&
                this.selectedArea !== null) {
                this.showWarning = false;
                const id = self.crypto.randomUUID();
                try {
                    await set(ref(getDatabase(), 'employee/' + id), {
                        id: id,
                        name: this.name,
                        surname: this.surname,
                        selectedStatus: this.selectedStatus,
                        selectedArea: this.selectedArea
                    });
                    this.showSuccessAlert();
                    this.hideModal();
                    return;
                } catch (err) {
                    this.showErrorAlert();
                    this.hideModal();
                    return;
                }
            } else {
                this.showWarning = true;
            }
        },
        async saveStaffDistribution() {
            if (
                this.staffDistribution.aushilfe === null ||
                this.staffDistribution.headOfLogistics === null ||
                this.staffDistribution.dropshipping === null ||
                this.staffDistribution.wareneingang === null ||
                this.staffDistribution.warenausgang === null ||
                this.staffDistribution.miniJobber === null ||
                this.staffDistribution.auszubildende === null
            ) {
                this.showWarningStaffDistribution = true;
                return;
            }
            this.showWarningStaffDistribution = false;
            try {
                await set(ref(getDatabase(), 'laborAllocation/'), {
                    areaDistribution: this.staffDistribution
                });
                this.showSuccessAlert();
                this.hideStaffDistributionModal();
                return;
            } catch (err) {
                this.showErrorAlert();
                this.hideStaffDistributionModal();
                return;
            }

        },
        hideStaffDistributionModal() {
            this.$refs['Warehouse-area-modal'].hide()
        },
        enableEdit(item) {
            this.enableEditButton = true;
            this.tempEmployeeId = item.id;
            this.name = item.name;
            this.surname = item.surname;
            this.selectedArea = item.selectedArea;
            this.selectedStatus = item.selectedStatus;
            this.showModal();
        },
        async saveChanges() {
            if (
                this.name !== null &&
                this.surname !== null &&
                this.selectedStatus !== null &&
                this.selectedArea !== null) {
                this.showWarning = false;
                try {
                    update(ref(getDatabase(), 'employee/' + this.tempEmployeeId), {
                        id: this.tempEmployeeId,
                        name: this.name,
                        surname: this.surname,
                        selectedStatus: this.selectedStatus,
                        selectedArea: this.selectedArea
                    })
                    this.hideModal();
                    return
                } catch (error) {
                    this.hideModal();
                    this.showErrorAlert();
                    return;
                }
            } else {
                this.showWarning = true;
            }

        },
        deleteEmployee(id) {
            remove(ref(getDatabase(), 'employee/' + id))
        },
        getAttendanceList() {
            const attendanceSheetRef = ref(getDatabase(), 'employee/');
            onValue(attendanceSheetRef, (snapshot) => {
                this.attendanceSheet = snapshot.val();
            });
            return null;
        },
        async handleData() {
            this.sortedAreaList.headOfLogistics = [];
            this.sortedAreaList.wareneingang = [];
            this.sortedAreaList.warenausgang = [];
            this.sortedAreaList.miniJobber = [];
            this.sortedAreaList.auszubildende = [];
            this.sortedAreaList.aushilfe = [];
            this.sortedAreaList.dropshipping = [];

            for await (const item of Object.entries(this.attendanceSheet)) {
                const selectedArea = item[1].selectedArea;
                if (selectedArea === "Head of Logistics") {
                    this.sortedAreaList.headOfLogistics.push(item[1])
                }
                if (selectedArea === "Wareneingang") {
                    this.sortedAreaList.wareneingang.push(item[1])
                }
                if (selectedArea === "Warenausgang") {
                    this.sortedAreaList.warenausgang.push(item[1])
                }
                if (selectedArea === "Aushilfe") {
                    this.sortedAreaList.aushilfe.push(item[1])
                }
                if (selectedArea === "MiniJobber") {
                    this.sortedAreaList.miniJobber.push(item[1])
                }
                if (selectedArea === "Auszubildende") {
                    this.sortedAreaList.auszubildende.push(item[1])
                }
                if (selectedArea === "Dropshipping") {
                    this.sortedAreaList.dropshipping.push(item[1])
                }
            }
            return null;
        }
    },
    mounted() {
        this.getAttendanceList();
    }
}
</script>
<style scoped>
p {
    margin: 0;
}

.list-header {
    display: grid;
    padding: 0 1rem;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    font-weight: 900;
}

.selected-area {
    padding: 1rem 0.5rem;
}

.employee-list {
    margin: 1.3rem 0;
    padding: 1rem 1rem;
    background-color: rgba(226, 224, 224, 0.443);
    box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
    border-radius: 8px;
}

.employee {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
}

.employee>div {
    display: flex;
    justify-content: left;
    align-items: center;
}

.employee>div>p {
    font-size: large;
}
</style>